import React, { Component, Fragment } from "react";
import {
  FieldGroup,
  FieldControl,
  Validators,
  FormBuilder
} from "react-reactive-form";
import { Link } from "react-router-dom";
import { Auth } from "aws-amplify";
import { readableResponseMessage } from "ux-helpers";
import PropTypes from "proptypes";

export default class ResetPassword extends Component {
  state = {
    successfulResetPassword: false
  };

  componentDidMount() {
    window.scrollTo({
      top: 400,
      behavior: 'smooth',
    })
  }

  handleSubmit = (e, form) => {
    e.preventDefault();
    this.resetPassword(form);
  };

  resetPassword = async form => {
    if (this.resetPasswordForm.status === "VALID") {
      this.setState({ loadingBtn: true });
      this.resetPasswordForm.handleSubmit();
      Auth.forgotPasswordSubmit(
        this.props.emailAddress,
        form.code,
        form.newPassword
      )
        .then(() => {
          this.setState({ successfulResetPassword: true });
          setTimeout(() => {
            this.props.history.push("/");
          }, 4000);
        })
        .catch(error => {
          this.setState({
            loadingBtn: false,
            message: readableResponseMessage(error)
          });
          this.resetPasswordForm.handleSubmit();
        });
    } else {
      this.resetPasswordForm.handleSubmit();
    }
  };

  resendCode = async emailAddress => {
    Auth.forgotPassword(emailAddress)
      .then(() => {
        this.setState({ successfulResendCode: true });
        setTimeout(() => {
          this.setState({ successfulResendCode: false });
        }, 3000);
      })
      .catch(() => {});
  };

  resetPasswordForm = FormBuilder.group({
    emailAddress: [this.props.emailAddress],
    code: ["", Validators.required],
    newPassword: ["", Validators.required]
  });

  render() {
    return (
      <div className="col-md-6 col-sm-12">
        <h2>Reset your password</h2>
        <p>
          Please check your email for your code and input your new password.
        </p>
        {this.state.message ? (
          <p className="error">{this.state.message}</p>
        ) : (
          ""
        )}
        {this.state.successfulResetPassword ? (
          <div>
            <p className="success">
              You have successfully reset your password. &#x2714;
              <br />
              You will be directed back to Sign-in.
            </p>
          </div>
        ) : null}
        {this.state.successfulResendCode ? (
          <div>
            <p className="success">
              We&apos;ve successfully resent a password reset code. &#x2714;
            </p>
          </div>
        ) : null}
        <p className="error-message">{this.state.errorMessage}</p>
        <div>
          <Fragment>
            <FieldGroup
              control={this.resetPasswordForm}
              render={({ value, submitted }) => (
                <form
                  name="Reset Password"
                  id="reset-password-form"
                  onSubmit={e => this.handleSubmit(e, value)}
                  autoComplete="off"
                >
                  <FieldControl
                    name="emailAddress"
                    render={({ handler, touched, hasError, pristine }) => (
                      <div className="inputContainer">
                        <input
                          className="form-control"
                          type="hidden"
                          {...handler()}
                        />
                        <label
                          htmlFor="emailAddress"
                          className={`label ${pristine ? "" : "notEmpty"}`}
                        >
                          Email Address
                          <span className="error">
                            {(touched || submitted) &&
                              hasError("required") &&
                              " - Required"}
                            {touched &&
                              hasError("email") &&
                              " - Not a Valid Email"}
                          </span>
                        </label>
                      </div>
                    )}
                  />
                  <FieldControl
                    name="code"
                    render={({ handler, touched, hasError, pristine }) => (
                      <div className="inputContainer">
                        <input
                          className="form-control"
                          type="number"
                          {...handler()}
                        />
                        <label
                          htmlFor="code"
                          className={`label ${pristine ? "" : "notEmpty"}`}
                        >
                          Password Reset Code
                          <span className="error">
                            {(touched || submitted) &&
                              hasError("required") &&
                              " - Required"}
                          </span>
                        </label>
                      </div>
                    )}
                  />
                  <FieldControl
                    name="newPassword"
                    render={({ handler, touched, hasError, pristine }) => (
                      <div className="inputContainer">
                        <input
                          className="form-control"
                          type="password"
                          autoComplete="new-password"
                          {...handler()}
                        />
                        <label
                          htmlFor="newPassword"
                          className={`label ${pristine ? "" : "notEmpty"}`}
                        >
                          Enter New Password
                          <span className="error">
                            {(touched || submitted) &&
                              hasError("required") &&
                              " - Required"}
                          </span>
                        </label>
                      </div>
                    )}
                  />
                  <button
                    className={`${
                      this.state.loadingBtn ? "btn-text-hide" : ""
                    }`}
                    type="submit"
                    disabled={this.state.loadingBtn}
                  >
                    Submit
                    <span
                      className={`${this.state.loadingBtn ? "loader" : ""}`}
                    />
                  </button>
                  <br />
                  <button
                    className="btn-plain-text"
                    type="button"
                    onClick={() => this.resendCode(this.props.emailAddress)}
                  >
                    Resend Code
                  </button>
                </form>
              )}
            />
            <p>
              Back to <Link to="/"> Sign In </Link>
            </p>
          </Fragment>
        </div>
      </div>
    );
  }
}

ResetPassword.propTypes = {
  emailAddress: PropTypes.string.isRequired
};
